import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "items-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_equipement_intervention_item = _resolveComponent("equipement-intervention-item")!
  const _component_modal_card = _resolveComponent("modal-card")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, null, {
    default: _withCtx(() => [
      _createVNode(_component_modal_card, {
        activeValidate: true,
        onConfirm: _ctx.confirm,
        onCancel: _ctx.cancel,
        headerTitle: _ctx.$t('equipement.intervention.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.equipementInterventions.length === 1
                            ? _ctx.$t('equipement.intervention.subtitle.single')
                            : _ctx.$t('equipement.intervention.subtitle.multiple')) + " ", 1),
              _createVNode(_component_ReglePastille, { cle: "demandeIntervention.interventionEnCours" })
            ]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipementInterventions, (intervention) => {
                return (_openBlock(), _createBlock(_component_equipement_intervention_item, {
                  equipementIntervention: intervention,
                  key: intervention.id
                }, null, 8, ["equipementIntervention"]))
              }), 128))
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('equipement.intervention.confirmation')), 1)
          ])
        ]),
        _: 1
      }, 8, ["onConfirm", "onCancel", "headerTitle"])
    ]),
    _: 1
  }))
}